import { Component, OnInit } from '@angular/core'
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms'
import { BreadcrumbService } from '../../shared-components/breadcrumb.service'
import { Router, ActivatedRoute } from '@angular/router'
import { DataPageOfUser, User } from '../../../../api/models'
import { UserService } from '../../../../api/services/user.service'
import { LazyLoadEvent, MessageService } from 'primeng/api'
import { environment } from '../../../../../environments/environment'
import { validateAllFormFields } from '../../../../formUtils'
import { CareFinityValidators } from '../../../validators/CareFinityValidators'

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit {
  users: DataPageOfUser = {}
  selectedUser: User
  cols: any[]
  lastName: string
  firstName: string
  practiceId: string
  rows: number
  resetPasswordForm: UntypedFormGroup
  errorValidationSummary = ''
  ShowErrorSummary = false

  constructor(
    private fb: UntypedFormBuilder,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
  ) {
    this.breadcrumbService.setItems([{ label: '' }])
  }
  resetSearchForm: UntypedFormGroup
  checked: boolean
  Ischildchecked: boolean
  selectedUsers: any[] = null
  displayResetPassword: boolean
  first: number = 0 // Variable to track the first record

  ngOnInit() {
    this.resetPasswordForm = this.fb.group({
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    })

    this.resetPasswordForm.setValidators(
      CareFinityValidators.Match('newPassword', 'confirmPassword'),
    )

    this.practiceId = localStorage.getItem('PracticeId')
    //  { field: 'active', header: 'Active' },
    this.cols = [
        { field: 'lname', header: 'Last Name' },
      { field: 'fname', header: 'First Name' },
      { field: 'mi', header: 'MI' },
      { field: 'loginId', header: 'Login Name' },
      { field: 'ehrUserName', header: 'EHR UserName' },
    ]
  }

  onResetPassword(pwd: string): void {
    validateAllFormFields(this.resetPasswordForm)
    if (this.resetPasswordForm.invalid) {
      return
    }
    console.log('onResetPassword Called')

    let userid = ''
    this.selectedUsers.forEach(function (value) {
      userid = userid + ',' + value.userId
    })

    this.userService
      .userResetAllPassword({
        Password: this.resetPasswordForm.get('newPassword').value,
        userIDs: userid,
      })
      .subscribe((X) => {
        if (X.status.toLowerCase().indexOf('error') > -1) {
          this.ShowErrorSummary = true
          this.errorValidationSummary = X.message
            this.messageService.add({
                key: 'alertToast',
            severity: 'error',
            summary: 'ERROR',
            detail: X.message,
          })
        } else if (X.status.toLowerCase().indexOf('ok') > -1) {
          this.resetPage()
          this.getUserList(1)
          this.ShowErrorSummary = false
            this.messageService.add({
                key: 'alertToast',
            severity: 'success',
            summary: 'Confirmation',
            detail: X.message,
          })
          this.displayResetPassword = false
        }
      })
  }

  onDisplayResetPassword(): void {
    if (this.selectedUsers != null) {
      this.displayResetPassword = true
    } else {
      this.messageService.add({
        key: 'alertToast',
        severity: 'error',
        detail: 'Please select Users !',
        summary: 'ERROR',
        life: 5000,
      })
      return
    }
  }

  onCancel(): void {
    this.displayResetPassword = false
  }
  clearUserList(): void {
    this.lastName = ''
    this.firstName = ''
    this.getUserList(1)
  }
  getUserList(pageNumber: number): void {
    //let serachtext = ''
    //if (this.lastName != '') {
    //  serachtext = this.lastName
    //} else if (this.firstName != '') {
    //  serachtext = this.firstName
      //}

      let serachtext = '';


      console.log(this.lastName);
      console.log(this.lastName);

      if (this.lastName && this.lastName.trim() !== '') {
          serachtext += "#LN#" + this.lastName.trim();
      }

      if (this.firstName && this.firstName.trim() !== '') {
          if (serachtext !== '') {
              serachtext += " AND ";
          }
          serachtext += "#FN#" + this.firstName.trim();
      }


    this.userService
      .userSearch({
        practiceId: this.practiceId,
        pageSize: 10,
        pageNumber,
        searchText: serachtext,
        SortByColumn: 'loginId',
        SortByDirection: 'Asc',
      })
      .subscribe((users) => {
        this.users = users
        this.rows = this.users.pageSize
      })
  }
  nextPage($event: LazyLoadEvent) {
    debugger
    console.log($event)
    const nextPage = $event.first / $event.rows + 1
    if ($event.first == 0) {
      this.getUserList(1)
    } else {
      this.getUserList(nextPage)
    }
  }

  resetPage() {
    this.first = 0 // Set the paginator to the first page
    this.selectedUsers = null
    this.resetPasswordForm.reset()
  }
}
